import { WebsiteBuilderConfigActionType } from "./websiteBuilderConfigAction";
import { GetWebsiteBuilderWebsite } from "api/rpc/2024-04/facilityAdmin/websiteBuilder/websiteBuilder";
import { StatusCode } from "api/protocols";
import { ISetWebsiteAction, ISetWebsiteActionPayload } from "./actions/setWebsite";
import { TWebsiteBuilderWebsiteLoadingStatus } from "redux/reducers/websiteBuilder/websiteBuilderConfig";
import { IWebsiteBuilderWebsite } from "redux/reducers/models/websiteBuilder";
import { showError } from "redux/actions/ui";
import { AppDispatch } from "index";
import { TFunction } from "i18next";

export function websiteBuilderLoadWebsite(facility_id: number, t: TFunction): (dispatch: AppDispatch) => Promise<void> {
  return async (dispatch: AppDispatch) => {
    dispatch({
      type: WebsiteBuilderConfigActionType.START_LOADING_WEBSITE,
    });

    const res = await GetWebsiteBuilderWebsite({ facility_id }, false);

    if (res.status !== StatusCode.OK) {
      dispatch(showError(typeof res.data === "string" ? res.data : t("Error loading website")));
    }

    const website: IWebsiteBuilderWebsite = res.status === StatusCode.OK ? res.data.website : null;
    const websiteLoadingStatus: TWebsiteBuilderWebsiteLoadingStatus = res.status === StatusCode.OK ? "succeeded" : "failed";

    dispatch({
      type: WebsiteBuilderConfigActionType.LOAD_WEBSITE,
      payload: {
        website,
        websiteLoadingStatus,
      },
    });
  };
}

export function websiteBuilderSetWebsite(payload: ISetWebsiteActionPayload): ISetWebsiteAction {
  return {
    type: WebsiteBuilderConfigActionType.SET_WEBSITE,
    payload,
  };
}